export enum PropertySelectFormatEnum {
  owner = 'owner',
  tenant = 'tenant',
}
